import type * as React from "react";

/**
 * Wraps a floating-overlay interaction handler so the event stops at the
 * overlay boundary. React re-dispatches portal events through the component
 * (owner) tree, not the DOM tree — so without this, a click inside a portaled
 * popup also fires the click handlers of whatever container declared it
 * (click-to-expand cards, clickable rows), even though the popup visually
 * floats above that UI. Overlay atoms (hover card, popover) apply this to the
 * activation events a covered surface could plausibly act on.
 */
export function stopAtOverlayBoundary<E extends React.SyntheticEvent>(
  handler: ((event: E) => void) | undefined,
): (event: E) => void {
  return (event) => {
    handler?.(event);
    event.stopPropagation();
  };
}
